import { render } from "./manualOcr.vue?vue&type=template&id=9d6e3d36&scoped=true"
import script from "./manualOcr.vue?vue&type=script&lang=js"
export * from "./manualOcr.vue?vue&type=script&lang=js"

import "./manualOcr.vue?vue&type=style&index=0&id=9d6e3d36&lang=less&scoped=true"

import exportComponent from "/Users/imp/work/credit_chkra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d6e3d36"]])

export default __exports__